export default __webpack_public_path__ + "static/media/pagetab-2.2f98eb4d.svg";